import React from "react";
import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";

const TABS = [
  {
    key: "setup",
    label: "Setup",
    copy: "Bootstrap and access",
    to: "/admin/onboarding/setup",
  },
  {
    key: "room-categories",
    label: "Room categories",
    copy: "Drafts and apply",
    to: "/admin/onboarding/room-categories",
  },
  {
    key: "rooms",
    label: "Rooms",
    copy: "Drafts and apply",
    to: "/admin/onboarding/rooms",
  },
  {
    key: "room-rates",
    label: "Room rates",
    copy: "Drafts and apply",
    to: "/admin/onboarding/room-rates",
  },
  {
    key: "reservation-settings",
    label: "Reservation settings",
    copy: "Drafts and apply",
    to: "/admin/onboarding/reservation-settings",
  },
  {
    key: "extras-discounts",
    label: "Extras & Discounts",
    copy: "Drafts and apply",
    to: "/admin/onboarding/extras-discounts",
  },
  {
    key: "booking-engine",
    label: "Booking Engine",
    copy: "Direct sales draft",
    to: "/admin/onboarding/booking-engine",
  },
];

export default function OnboardingAdminHub() {
  const location = useLocation();

  if (location.pathname === "/admin/onboarding" || location.pathname === "/admin/onboarding/") {
    return <Navigate to="/admin/onboarding/setup" replace />;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <section
        style={{
          margin: "24px 24px 0",
          borderRadius: "24px",
          padding: "20px 22px",
          border: "1px solid rgba(255,255,255,0.08)",
          background:
            "radial-gradient(680px 220px at 0% 0%, rgba(92,191,255,0.12), transparent 60%), rgba(10,15,28,0.9)",
          boxShadow: "0 24px 60px rgba(0,0,0,0.22)",
        }}
      >
        <div style={{ fontSize: "0.76rem", textTransform: "uppercase", letterSpacing: "0.12em", color: "#8ea0bc" }}>
          Admin onboarding
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "16px",
            alignItems: "flex-end",
            flexWrap: "wrap",
            marginTop: "10px",
          }}
        >
          <div>
            <h2 style={{ color: "#fff", margin: 0 }}>Onboarding</h2>
            <p style={{ color: "#b9c3d7", maxWidth: "840px", margin: "8px 0 0", lineHeight: 1.6 }}>
              Everything related to onboarding stays grouped here: access setup, staged drafts and live apply flows.
              Only theme and language apply directly from the hotel-side onboarding. Everything else must be reviewed
              and applied from this admin panel.
            </p>
          </div>

          <nav style={{ display: "flex", gap: "10px", flexWrap: "wrap" }} aria-label="Onboarding admin sections">
            {TABS.map((tab) => (
              <NavLink
                key={tab.key}
                to={tab.to}
                style={({ isActive }) => ({
                  minWidth: "180px",
                  textDecoration: "none",
                  borderRadius: "16px",
                  padding: "12px 14px",
                  border: `1px solid ${isActive ? "rgba(92,191,255,0.45)" : "rgba(255,255,255,0.08)"}`,
                  background: isActive ? "rgba(92,191,255,0.1)" : "rgba(255,255,255,0.03)",
                  color: "#fff",
                  boxShadow: isActive ? "0 14px 36px rgba(92,191,255,0.12)" : "none",
                })}
              >
                <div style={{ fontWeight: 700 }}>{tab.label}</div>
                <div style={{ marginTop: "4px", fontSize: "0.84rem", color: "#9db0cf" }}>{tab.copy}</div>
              </NavLink>
            ))}
          </nav>
        </div>
      </section>

      <Outlet />
    </div>
  );
}
